// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__IekQU","col":"Table_col__2KFI-","fulfillmentStatus":"Table_fulfillmentStatus__34Uni","emailCol":"Table_emailCol__2hbHM"};